import React, { Component } from 'react'
import PropTypes from 'prop-types'
import GroupItem from './GroupItem'
import SortContainer from '../SortContainer'

export default class extends Component {
  static propTypes = {
    group: PropTypes.object,
    items: PropTypes.array,
    path: PropTypes.string
  }

  static contextTypes = {
    editing: PropTypes.bool
  }

  didSort = items => {
    const {group} = this.props

    items.forEach((item, i) => {
      item.group_id = group.id
      item.display_order = i
    })
  }

  renderItem = item => {
    const {path, activeId} = this.props
    const {editing} = this.context
    const active = item.id === activeId

    return <GroupItem item={item} url={`${path}/${item.slug}`}
      active={active} editing={editing} />
  }

  render () {
    const {connectDragSource, group, items, onEdit} = this.props
    const {editing} = this.context

    const component = <ul className='group'>
      <SortContainer
        id={group.id}
        itemType='TYPE'
        items={items}
        didSort={this.didSort}
        renderItem={this.renderItem}
      >
        <li className='title'>
          {group.name}
          {(group.id && editing) &&
            <a role='button' onClick={onEdit}>Edit</a>
          }
        </li>
        {(!editing && !items.length) && <li>Empty</li>}
      </SortContainer>
    </ul>

    return (editing && connectDragSource)
      ? connectDragSource(component)
      : component
  }
}



// WEBPACK FOOTER //
// ./app/components/sidebar/Group.js